import React, { useRef } from "react";
import { splitKeys } from "../../../features/smallFunction/SmallFunctions";
// const renderIcon = (type, color) => {
//     switch (type) {
//         case "circle":
//             return (
//                 <svg width="12" height="12">
//                     <circle cx="6" cy="6" r="6" fill={color} />
//                 </svg>
//             );
//         case "square":
//             return (
//                 <svg width="12" height="12">
//                     <rect width="12" height="12" fill={color} />
//                 </svg>
//             );
//         case "rect":
//             return (
//                 <svg width="12" height="8">
//                     <rect width="12" height="8" fill={color} />
//                 </svg>
//             );
//         case "cross":
//             return (
//                 <svg width="12" height="12">
//                     <line x1="0" y1="0" x2="12" y2="12" stroke={color} strokeWidth="2" />
//                     <line x1="12" y1="0" x2="0" y2="12" stroke={color} strokeWidth="2" />
//                 </svg>
//             );
//         case "diamond":
//             return (
//                 <svg width="12" height="12">
//                     <polygon points="6,0 12,6 6,12 0,6" fill={color} />
//                 </svg>
//             );
//         case "star":
//             return (
//                 <svg width="12" height="12">
//                     <polygon
//                         points="6,0 7.5,4 12,4 8,6 9,10 6,8 3,10 4,6 0,4 4.5,4"
//                         fill={color}
//                     />
//                 </svg>
//             );
//         case "triangle":
//             return (
//                 <svg width="12" height="12">
//                     <polygon points="6,0 12,12 0,12" fill={color} />
//                 </svg>
//             );
//         case "wye":
//             return (
//                 <svg width="12" height="12">
//                     <polygon points="6,0 12,12 0,12 3,6" fill={color} />
//                 </svg>
//             );
//         case "line":
//             return (
//                 <svg width="12" height="2">
//                     <line x1="0" y1="1" x2="12" y2="1" stroke={color} strokeWidth="2" />
//                 </svg>
//             );
//         case "plainline":
//             return (
//                 <svg width="12" height="2">
//                     <line x1="0" y1="1" x2="12" y2="1" stroke={color} strokeWidth="1" />
//                 </svg>
//             );
//         default:
//             return null; // Return null for unknown icon types
//     }
// };

const CustomLegend = (props) => {
  const {
    payload,
    align,
    verticalAlign,
    layout,
    containerHeight,
    containerWidth,
    valueKeys,
  } = props;

  const containerRef = useRef(null);
  console.log(payload);

  const itemsOverflow =
    layout === "vertical" ? "overflow-y-auto" : "overflow-x-auto";
  const itemsTextTruncate =
    layout === "vertical" ? "overflow-hidden" : "overflow-x-hidden";
  const itemsAlignment = layout === "vertical" ? "flex-col" : "flex-row ";
  const displayFlex =
    layout === "vertical"
      ? "flex-col overflow-y-auto"
      : "  overflow-x-auto gap-2";

  const horizontalPosition =
    layout === "horizontal"
      ? align === "center"
        ? "justify-center"
        : align === "left"
          ? "justify-start"
          : "justify-end"
      : "";

  if (!Array.isArray(payload)) {
    return null;
  }

  const visibleLegendData = payload.slice(0, payload.length); // or payload.slice(currentIndex, currentIndex + payload.length)
  const legendData = visibleLegendData.map((item, index) => {
    let { color, value, name } = item;

    if (valueKeys && valueKeys.length === 1) {
      value = splitKeys(value);
    }
    console.log(value);

    return (
      <div
        key={index}
        className="flex items-center"
        style={{
          display: "flex",
          alignItems: "center",
          padding: "2px", // Padding for spacing

          boxSizing: "border-box", // Include padding and border in width
          // width: itemWidth,
        }}
      >
        {/* Color rectangle */}
        <div
          style={{
            backgroundColor: color,
            width: "12px",
            height: "12px",
            marginRight: "4px", // Space between rectangle and text
            display: "inline-block",
          }}
        />

        <p className={`whitespace-nowrap ${itemsTextTruncate} text-ellipsis`}>
          {name} {value}
        </p>
      </div>
    );
  });
  console.log(visibleLegendData);
  console.log(legendData);

  return (
    <div
      className={`flex items-center  ${horizontalPosition} gap-1`}
      style={{ maxWidth: containerWidth, align: "right" }}
    >
      {/* Conditionally render icons based on layout */}
      {layout === "vertical" ? null : (
        <div>{/* Your icon or component here for horizontal layout */}</div>
      )}

      <div
        ref={containerRef}
        className={`flex ${displayFlex} items-left    max-w-full  custom-scrollbar`}
        style={
          layout === "vertical"
            ? { maxHeight: containerHeight, height: "auto" }
            : {}
        }
      >
        {legendData}
      </div>

      {layout === "vertical" ? null : <div></div>}
    </div>
  );
  // return (<div className="w-full text-left">
  //     <p>Mohit</p>
  // </div>)
};

export { CustomLegend };
